"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDashboardMetadataObject = void 0;
// (C) 2019-2021 GoodData Corporation
var types_1 = require("../types");
/**
 * Tests whether the provided object is of type {@link IDashboardMetadataObject}.
 *
 * @param obj - object to test
 * @public
 */
function isDashboardMetadataObject(obj) {
    return types_1.isMetadataObject(obj) && obj.type === "analyticalDashboard";
}
exports.isDashboardMetadataObject = isDashboardMetadataObject;
//# sourceMappingURL=index.js.map